"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapProductBoxPropsFromGql = void 0;
var _internal = require("./internal");
const mapProductBoxPropsFromGql = params => (0, _internal.mapProductBoxProps)(params);
exports.mapProductBoxPropsFromGql = mapProductBoxPropsFromGql;
